module.exports = __webpack_public_path__ + "img/news.0a615bcd.png";